import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RiGlobalLine, RiArrowDownSLine, RiCheckLine } from 'react-icons/ri';
import LanguageContext from '../../contexts/LanguageContext';
import ThemeContext from '../../contexts/ThemeContext';
import './LanguageSwitcher.css';

const REGION_OPTIONS = {
    ils: [
        { path: '/he', code: 'he', label: 'עברית' },
        { path: '/ar', code: 'ar', label: 'عربي' },
    ],
    usd: [
        { path: '/ae', code: 'ar', label: 'العربية' },
        { path: '/en', code: 'en', label: 'English' },
    ],
};

const LanguageSwitcher = ({ cur }) => {
    const region = cur === '$' ? 'usd' : 'ils';
    const options = REGION_OPTIONS[region];
    const location = useLocation();
    const navigate = useNavigate();
    const { changeLang } = useContext(LanguageContext);
    const { theme } = useContext(ThemeContext);
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const segment = location.pathname.split('/').filter(Boolean)[0];
    const current =
        options.find((o) => o.path === `/${segment}`) || options[0];
    const fontClass = segment === 'en' || segment === 'he' ? 'he' : 'ar';

    useEffect(() => {
        if (['he', 'ar', 'ae', 'en'].includes(segment)) {
            const match = REGION_OPTIONS[region].find(
                (o) => o.path === `/${segment}`
            );
            if (match) changeLang(match.code);
        }
    }, [segment, region, changeLang]);

    useEffect(() => {
        const onOutside = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onOutside);
        return () => document.removeEventListener('mousedown', onOutside);
    }, []);

    const selectLanguage = (option) => {
        navigate(option.path);
        changeLang(option.code);
        setOpen(false);
    };

    return (
        <div
            className={`LanguageSwitcher LanguageSwitcher--${theme.mode} ${fontClass}`}
            ref={rootRef}
        >
            <button
                type="button"
                className="LanguageSwitcher-trigger"
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
                aria-haspopup="listbox"
                aria-label="Change language"
            >
                <RiGlobalLine size={16} color={theme.text} />
                <span className="LanguageSwitcher-label" style={{ color: theme.text }}>
                    {current.label}
                </span>
                <RiArrowDownSLine
                    size={16}
                    color={theme.text}
                    className={`LanguageSwitcher-chevron ${open ? 'is-open' : ''}`}
                />
            </button>

            {open && (
                <ul className="LanguageSwitcher-menu" role="listbox">
                    {options.map((option) => (
                        <li key={option.path}>
                            <button
                                type="button"
                                role="option"
                                aria-selected={current.path === option.path}
                                className={`LanguageSwitcher-option ${
                                    current.path === option.path ? 'is-active' : ''
                                }`}
                                style={{ color: theme.text }}
                                onClick={() => selectLanguage(option)}
                            >
                                <span>{option.label}</span>
                                {current.path === option.path && (
                                    <RiCheckLine size={16} color="var(--orange)" />
                                )}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSwitcher;
